import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { FilterComponentProp } from '../hocs/types'

const subCategoryProps: FilterComponentProp = {
    title: 'Subcategory',
    renderFilterBar: true,
}

export const SubCategory = withFacetContext(
    FacetName.sub_style,
    withFilterContext(FilterName.sub_style, SearchFiltersDropdown, subCategoryProps)
)
